"use client"

import type React from "react"
import { useState, useRef, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import ThemeToggle from "../components/auth/ThemeToggle"

const OtpVerification: React.FC = () => {
  const navigate = useNavigate()
  const [otp, setOtp] = useState<string[]>(Array(6).fill(""))
  const inputRefs = useRef<(HTMLInputElement | null)[]>([])

  useEffect(() => {
   
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus()
    }
  }, [])

  const handleChange = (index: number, value: string) => {
    
    if (!/^\d*$/.test(value)) return

    const newOtp = [...otp]
    newOtp[index] = value.slice(0, 1) 
    setOtp(newOtp)

    
    if (value && index < 5 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1]!.focus()
    }
  }

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    
    if (e.key === "Backspace" && !otp[index] && index > 0 && inputRefs.current[index - 1]) {
      inputRefs.current[index - 1]!.focus()
    }
  }

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault()
    const pastedData = e.clipboardData.getData("text/plain").trim()


    if (!/^\d+$/.test(pastedData)) return

    const digits = pastedData.slice(0, 6).split("")
    const newOtp = [...otp]

    digits.forEach((digit, index) => {
      if (index < 6) {
        newOtp[index] = digit
      }
    })

    setOtp(newOtp)

    // Focus the next empty input or the last input if all are filled
    const nextEmptyIndex = newOtp.findIndex((val) => !val)
    if (nextEmptyIndex !== -1 && inputRefs.current[nextEmptyIndex]) {
      inputRefs.current[nextEmptyIndex]!.focus()
    } else if (inputRefs.current[5]) {
      inputRefs.current[5]!.focus()
    }
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
   
    
    navigate("/reset-password")
  }

  return (
    <div className="  min-h-screen flex items-center justify-center bg-white dark:bg-[#261d57] text-gray-900 dark:text-white transition-all">
      <ThemeToggle /> 
    <div className="w-full max-w-6xl h-auto sm:h-[600px] rounded-2xl overflow-hidden flex flex-col sm:flex-row" >
    <div className="hidden min-h-screen sm:flex sm:w-1/2 flex-col justify-between">
         <img src="./image.png"  alt="" className="w-full min-h-screen" />
     
      </div>

     
      <div className="w-full sm:w-1/2 p-6 rounded-2xl bg-gray-100 dark:bg-gray-800">
        <div className="flex flex-col items-center mb-6">
          <div className="bg-purple-600 p-3 rounded-full">
            <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold mt-4 text-gray-900 dark:text-white">OTP Verification</h1>
          <p className="text-gray-600 dark:text-gray-300 mt-1 text-center">We have sent a verification code to your email</p>
        </div>
  
        <form onSubmit={handleSubmit} className="space-y-6 w-full">
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-3 text-center">
              Enter 6-digit verification code
            </label>
            <div className="flex justify-center gap-2">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => {
                    inputRefs.current[index] = el;
                  }}
                  type="text"
                  value={digit}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={index === 0 ? handlePaste : undefined}
                  className="w-12 h-12 text-center bg-white border-gray-300 dark:bg-gray-800 border dark:border-gray-700 rounded-md text-white text-xl focus:ring-purple-500 focus:border-purple-500"
                  maxLength={1}
                  inputMode="numeric"
                  autoComplete="one-time-code"
                />
              ))}
            </div>
          </div>
  
          <div className="text-center">
            <p className="text-sm text-gray-400">
              Didn't receive the code?{" "}
              <button type="button" className="text-purple-500 hover:text-purple-400">
                Resend
              </button>
            </p>
          </div>
  
          <button
            type="submit"
            className="w-full bg-purple-600 hover:bg-purple-700 text-white font-medium py-2.5 px-4 rounded-md transition duration-150 ease-in-out"
            disabled={otp.some((digit) => !digit)}
          >
            Verify
          </button>
        </form>
  
        <p className="mt-6 text-center text-sm text-gray-400">
          <Link to="/forgot" className="text-purple-500 hover:text-purple-400">
            Back to Forgot Password
          </Link>
        </p>
      </div>
     
    </div>
  </div>
  
  )
}

export default OtpVerification

